<template>
  <div class="header">
    <div class="top">
      <div class="item-top">
        <div class="login">
        </div>
        <div class="conact">
<!--          <p class="tel"><span></span>13534249901</p>-->
        </div>
      </div>
    </div>
    <div :class="navBarFixed == true ? 'nav-header sticky' :'nav-header'">
      <div class="container">
        <div class="header-meun">
          <!-- <router-link to="/index" class="item-meun" active-class="nav">
            <span>首页</span>
          </router-link>
          <router-link to="/brandIntr" class="item-meun" active-class="nav">
            <span>品牌介绍</span>
          </router-link>
          <router-link  to="/classSystem" class="item-meun" active-class="nav">
            <span>课程体系</span>
          </router-link>
          <router-link to="/teacherTeams" class="item-meun" active-class="nav">
            <span>师资团队</span>
          </router-link>
          <router-link to="/studentStatus" class="item-meun" active-class="nav">
            <span>学园动态</span>
          </router-link> -->
          <div class="item-meun"
            active-class="nav"
            style="position:relative"
            @mouseover="mouseover"
            @mouseleave="mouseleave">
            <span>官方考级</span>
            <div class="chess" v-if="isChess">
              <router-link class="ischess" to="/grading" target="_blank">中国象棋</router-link>
              <!-- <router-link class="ischess" to="/goNotice" target="_blank">围棋</router-link> -->
              <router-link class="ischess" to="/chessNotice" target="_blank">国际象棋</router-link>
            </div>
          </div>
          <!-- <router-link to="/aboutUs" class="item-meun" active-class="nav">
            <span>关于我们</span>
          </router-link> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NavHeader',
  data () {
    return {
      navBarFixed: false,
      showseach: false,
      showlogin: false,
      status: false,
      isChess: false
    }
  },
  created () {
  },
  mounted () {
    // 事件监听滚动条
    window.addEventListener('scroll', this.watchScroll)
  },
  methods: {
    watchScroll () {
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      //  当滚动超过 50 时，实现吸顶效果
      if (scrollTop > 49) {
        this.navBarFixed = true
      } else {
        this.navBarFixed = false
      }
    },
    mouseover () {
      this.isChess = true
    },
    mouseleave () {
      this.isChess = false
    }
  }

}
</script>

<style lang="scss" scoped>
  @import "../assets/scss/base.scss";
  @import "../assets/scss/mixin.scss";
  @import "../assets/scss/config.scss";
  .header{
    width: 100%;
    @media only screen and (min-width: 540px) and (max-width: 1180px){
      width: 1180px;
    }
    padding: 0;
    margin: 0;
    .top{
      width: 100%;
      height: 80px;
      background-color: #ffffff;
      .item-top {
        width: 1180px;
        margin: auto;
        height: 80px;
        @include flex();
        justify-content: space-between;
        .conact{
          p{
            display: inline-block;
            vertical-align: middle;
            font-size: $fontF;
            color: $colorI;
          }
          .tel {
            margin-left: 20px;
            @media only screen and (min-width: 540px) and (max-width: 1180px){
              padding-right: 40px;
            }
            span {
              width: 16px;
              height: 18px;
              vertical-align: middle;
              margin-right: 9px;
            }
          }
        }
        .login{
          width: 168px;
          @include bgImg(168px,68px,'../assets/imgs/logo.png');
          align-items: center;
          @media only screen and (min-width: 540px) and (max-width: 1180px){
            padding-left: 40px;
          }
          p{
            width: 100%;
            text-align: center;
            line-height: 54px;
            &:hover{
              color: $colorA;
            }
          }
          .item-login{
            position: absolute;
            width: 100%;
            background-color: #fff;
            z-index:222;
            border-radius: 3%;
            box-shadow: 1px 2px 4px 0px #eeeeee;
            padding: 10px;
            box-sizing: border-box;
            .demo-ruleForm {
              width: 100%;
            }
          }
        }
      }
    }
    .nav-header {
      width: 100%;
      @media only screen and (min-width: 540px) and (max-width: 1180px){
        width: 1180px;
      }
      height: 60px;
      line-height: 60px;
      /*margin-bottom: 20px;*/
      .container{
        width: 100%;
        height: 60px;
        background-color: $colorA;
        .header-meun{
          width: 1180px;
          display: inline-block;
          @include flex();
          margin: auto;
          .item-meun{
            width: 16.666%;
            height: 60px;
            display: inline-block;
            color: $colorG;
            line-height: 60px;
            text-align: center;
            font-size: $fontG;
            span{
              cursor: pointer;
            }
          }
          .nav{
              background-color: $colorM;
          }
        }
      }
    }
    .sticky{
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      background: #fff;
      z-index: 999;
      border-bottom: 1px solid #cecece;
      -webkit-box-shadow: 0px 0px 191px 0px rgba(0,0,0,0.06);
      box-shadow: 0px 0px 191px 0px rgba(0,0,0,0.06);
      transition: 2s;
    }

  }
  .chess{
    width: 100%;
    position: absolute;
    z-index: 9999999;
    width: 100%;
    background: #ffffff;
    font-size: 16px;
    display: flex;
    flex-wrap: wrap;
  }
  .chess>a{
    color: #555;
  }
  .ischess{
    width: 100%;
    border-bottom:1px solid #555;
  }
  .ischess:last-of-type{
    border: none;
  }
  .ischess:hover{
    color: #f19728;
    background: #eeeded;
  }
</style>



// WEBPACK FOOTER //
// src/components/NavHeader.vue